export enum DialogAction {
  CLOSE = 'CLOSE',
  OK = 'OK',
}

export interface DialogResult {
  action: DialogAction;
  data?: any;
}
